import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import {IndexService} from "../index.service";

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

    sistema: any = {};
	production:boolean;

	constructor(
	    private http: HttpClient,
        private indexService: IndexService) {
	}

	ngOnInit() {
		this.production=environment.production;
		this.getSistema();
	}

    getSistema(){
        this.indexService.getSistema()
            .subscribe(response =>{                
                this.sistema = response;

            }); 
    }

	throwError() {
		throw new Error('My Pretty Error*');
    }
    throwOtherError()
    {
        throw new Error('Other My Pretty Error*');
    }

	throwHttpError() {
		this.http.post('esta es un test***',{}).subscribe();
	}
}
